import React from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
// import Pagination from "react-js-pagination";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import choVayConst from "constants/choVayConst";
import configs from "constants/configs";
import configsRole from "utils/configsRole";
import { kiemTraQuyen, quyenBanDau } from "utils/quyenNguoiDung";
import { BtnChiTietHopDong } from "../ChiTietHopDong/BtnChiTietHopDong";

class ModalChiTietKhachHang extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSearch: {
        customerId: 0,
        pageIndex: 1,
        pageSize: 10,
      },
      quyenThongTinKhac: quyenBanDau(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      quyenThanhPhanGiaDinh: quyenBanDau(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      quyenGhiChu: quyenBanDau(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      quyenThongTinKhacGiaDinh: quyenBanDau(configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac),
    };
  }
  componentDidMount() {
    //Các quyền tab con của nhóm "Thông tin khách vay"
    //Quyền cấp 3: tắt thì chỉ ẩn đúng ô "Ghi chú" / "Thông tin khác"
    Promise.all([
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thongtinkhac_ghichu),
      kiemTraQuyen(configsRole.sRole.thongtinkhachvay_thanhphangiadinh_thongtinkhac),
    ]).then(
      ([
        quyenThongTinKhac,
        quyenThanhPhanGiaDinh,
        quyenGhiChu,
        quyenThongTinKhacGiaDinh,
      ]) =>
        this.setState({
          quyenThongTinKhac,
          quyenThanhPhanGiaDinh,
          quyenGhiChu,
          quyenThongTinKhacGiaDinh,
        })
    );
    let { data, getDetailCustomer, lichSuGiaoDich, show } = this.props;
    if (show) {
      let { dataSearch } = this.state;
      dataSearch.customerId = data.CustomerId;
      getDetailCustomer(dataSearch);
      lichSuGiaoDich(dataSearch);
      this.setState({ choVay: data, dataSearch });
    }
  }
  handlePageChange = (pageNumber) => {
    let { lichSuGiaoDich } = this.props;
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    lichSuGiaoDich(dataSearch);
  };
  showModalHopDong = (item) => () => {
    let { showChiTietHopDong } = this.props;
    if (showChiTietHopDong) showChiTietHopDong(item)();
  };
  render() {
    let props = this.props;
    let {
      quyenThongTinKhac,
      quyenThanhPhanGiaDinh,
      quyenGhiChu,
      quyenThongTinKhacGiaDinh,
    } = this.state;
    // let { dataSearch } = this.state;
    let { customer, show } = props;
    let { customerDetail, objLichSuGiaoDich, customerLoading } = customer;
    let {
      DinhDanh,
      CMT,
      AddressCMT,
      Phone,
      HKTT,
      Address,
      Birthday,
      DateCMT,
      UserName,
      TenNguonKh,
      DebtLevel,
      IsCus,
      Profession,
      WorkAddress,
      Income,
      PersonContact,
      PhoneContact,
      Note,
      PhoneFather,
      PhoneMother,
      PhoneWife,
      ProfessionFather,
      ProfessionMother,
      ProfessionWife,
      NameFather,
      NameMother,
      NameWife,
      NoteFamily,
      Img,
    } = customerDetail;
    let { TongGiaoDich, TongTienChoVay, List } = objLichSuGiaoDich;
    let image = Img;
    if (typeof Img === "undefined" || Img === "") {
      image = "Image/no_image.png";
    }
    if (image.indexOf("http") > -1) {
    } else {
      image = configs.apiViewUpload + image;
    }
    return (
      <Modal
        show={show}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <i className="mdi mdi-clipboard-account"></i>
            </span>
            Thông tin cá nhân
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div
            className={
              "loader loader-default " + (customerLoading ? "is-active" : "")
            }
          ></div>
          <div className="form-thongtin-kh-new">
            <div id="accordionWrap6" role="tablist" aria-multiselectable="true">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="accordion61"
                  aria-labelledby="heading61"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="thongtin-kh-new">
                        <div className="row">
                          <div className="col-md-2 no-image">
                            <div className="main-slider" id="main-slider1">
                              <a
                                href={
                                  image && image.indexOf("http") > -1
                                    ? image
                                    : image.indexOf("/Upload/TaiSanImage/") > -1
                                    ? configs.imageServer + image
                                    : configs.apiViewUpload + image
                                }
                                data-fancybox="images"
                              >
                                <img
                                  src={
                                    image && image.indexOf("http") > -1
                                      ? image
                                      : image.indexOf("/Upload/TaiSanImage/") >
                                        -1
                                      ? configs.imageServer + image
                                      : configs.apiViewUpload + image
                                  }
                                  width={180}
                                />
                              </a>
                            </div>
                          </div>

                          <div className="col-md-10">
                            <div className="from-thongtin1 form-mobile-chitietkh">
                              <div className="table-responsive table-new1">
                                <table className="table table-bordered">
                                  <tbody>
                                    <tr>
                                      <td className="text-left w-50 width-40">
                                        <span className="color-xanh-bold">
                                          {DinhDanh
                                            ? DinhDanh
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left" colSpan={2}>
                                        {/* Ngày sinh: {getDate(Birthday)} */}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-birthday-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Birthday)
                                            ? getDate(Birthday)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Số CCCD :
                                      </td>
                                      <td className="text-left width-70">
                                        {CMT ? CMT : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-so-dien-thoai-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Phone)
                                            ? getDate(Phone)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Ngày Cấp :
                                      </td>
                                      <td className="text-left width-70">
                                        {getDate(DateCMT)
                                          ? getDate(DateCMT)
                                          : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-dia-chi-v2.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(Address)
                                            ? getDate(Address)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Nợi cấp :
                                      </td>
                                      <td className="text-left width-70">
                                        {AddressCMT
                                          ? AddressCMT
                                          : "Không có thông tin"}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="text-left width-40">
                                        <img src="/app-assets/images/icon-nguoi-theo-doi.png" />
                                        <span className="color7">
                                          &nbsp;
                                          {getDate(UserName)
                                            ? getDate(UserName)
                                            : "Không có thông tin"}
                                        </span>
                                      </td>
                                      <td className="text-left width-10 color-tim-bold ">
                                        Hộ khẩu thường trú
                                      </td>
                                      <td className="text-left width-70">
                                        {HKTT ? HKTT : "Không có thông tin"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="tab-detail-hd">
            <Tabs className="tab-detail-mm">
              <Tab
                eventKey="lichsugiaodich"
                title={
                  <h4 className="nav-link">
                    <div className="badge badge-pill bg-blue-morman">
                      {TongGiaoDich}
                    </div>{" "}
                    Lịch sử giao dịch
                  </h4>
                }
              >
                <div className="table-noboder-new margin-top-20px">
                  <div className="table-responsive table-new1">
                    <table className="table table-bordered table-hover table-rounded">
                      <thead>
                        <tr>
                          <th className="w-5">STT</th>
                          <th className="w-15">Mã cho vay</th>
                          <th className="w-15">Ngày vay</th>
                          <th className="text-right">
                            Số tiền vay
                            <br />
                            <span className="color-do-bold">
                              $ = {formatNumber(TongTienChoVay)}
                            </span>
                          </th>
                          <th className="">Trạng thái</th>
                        </tr>
                      </thead>
                      <tbody>
                        {List.map((item, index) => (
                          <tr key={"lichSuGiaoDic" + item.ChoVayId}>
                            <td>{index + 1}</td>
                            <td>
                              {/* <a onClick={this.showModalHopDong(item)}>
                                {item.Code}
                              </a> */}
                              <BtnChiTietHopDong item={item} />
                            </td>
                            <td>{getDate(item.NgayVay)}</td>
                            <td className="text-right">
                              {formatNumber(item.Sotienvay)}
                            </td>
                            <td>{choVayConst.StatusText[item.Status]}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="footer-page-new">
                  <div className="col-xl-12 col-lg-12">
                    {/* <div className="paniation-new d-flex just-end">
                      <nav aria-label="Page navigation">
                        <Pagination
                          activePage={dataSearch.pageIndex}
                          itemsCountPerPage={dataSearch.pageSize}
                          totalItemsCount={parseInt(TongGiaoDich)}
                          pageRangeDisplayed={5}
                          onChange={this.handlePageChange}
                          itemClass="page-item"
                          linkClass="page-link"
                          activeClass="active"
                        />
                      </nav>
                    </div> */}
                  </div>
                </div>
              </Tab>
              {quyenThongTinKhac && (
              <Tab
                eventKey="thongtinkhac"
                title={
                  <h4 className="nav-link">
                    {" "}
                    <i className="mdi mdi-information"></i> Thông tin khác
                  </h4>
                }
              >
                <div className="table-from-detailaccout">
                  <div className="select-thongtinvay">
                    <div className="row">
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Nguồn khách hàng: {TenNguonKh}</p>
                          <p>
                            Tình trạng:{" "}
                            <span
                              className={choVayConst.DebtLevelColor[DebtLevel]}
                            >
                              {choVayConst.DebtLevelText[DebtLevel]}
                            </span>
                          </p>
                          <p>
                            Loại đối tác:{" "}
                            <span className="home-new-blue">
                              {IsCus ? "Khách hàng" : "Chủ nợ"}
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Nghề nghiệp: {Profession}</p>
                          <p>Nơi làm việc: {WorkAddress}</p>
                          <p>Thu nhập: {formatNumber(Income)}</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Người liên hệ: {PersonContact}</p>
                          <p>Số điện thoại người liên hệ: {PhoneContact}</p>
                        </div>
                      </div>
                      {quyenGhiChu && (
                        <div className="col-md-12 col-lg-12">
                          <div className="from-notevay">
                            <p>Ghi chú: {Note}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Tab>
              )}
              {quyenThanhPhanGiaDinh && (
              <Tab
                eventKey="thanhphangiadinh"
                title={
                  <h4 className="nav-link">
                    <i className="mdi mdi-account-multiple"></i> Thành phần gia
                    đình
                  </h4>
                }
              >
                <div className="table-from-detailaccout1">
                  <div className="select-thongtinvay">
                    <div className="row">
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Họ tên chồng/vợ: {NameWife}</p>
                          <p>Số điện thoại chồng/vợ: {PhoneWife}</p>
                          <p>Nghề nghiệp chồng/vợ: {ProfessionWife}</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Họ tên bố: {NameFather}</p>
                          <p>Số điện thoại bố: {PhoneFather}</p>
                          <p>Nghề nghiệp bố: {ProfessionFather}</p>
                        </div>
                      </div>
                      <div className="col-md-4 col-lg-4">
                        <div className="from-thongtinvay">
                          <p>Họ tên mẹ: {NameMother}</p>
                          <p>Số điện thoại mẹ: {PhoneMother}</p>
                          <p>Nghề nghiệp mẹ: {ProfessionMother}</p>
                        </div>
                      </div>
                      {quyenThongTinKhacGiaDinh && (
                        <div className="col-md-12 col-lg-12">
                          <div className="from-notevay">
                            <p>Ghi chú: {NoteFamily}</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Tab>
              )}
            </Tabs>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right">
            <button
              type="button"
              className="btn btn-new-main btn-closenew"
              onClick={props.onHide}
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-close"></i>
              </span>
              Đóng
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default ModalChiTietKhachHang;
